import { render } from "./ContactsPage.vue?vue&type=template&id=34282704"
const script = {}

import "./ContactsPage.vue?vue&type=style&index=0&id=34282704&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__